webpackJsonp([263791100135453],{

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  text-decoration: underline;\n  &:hover {\n    color: ', ';\n  }\n  transition: color 0.2s;\n'], ['\n  color: ', ';\n  text-decoration: underline;\n  &:hover {\n    color: ', ';\n  }\n  transition: color 0.2s;\n']);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _colors = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject, _colors.siteAccent, _colors.siteAccentBold);
	module.exports = exports['default'];

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  margin-bottom: 1rem;\n'], ['\n  text-align: center;\n  margin-bottom: 1rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = _styledComponents2.default.h1(_templateObject);
	module.exports = exports['default'];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SubHeader = __webpack_require__(31);
	
	var _SubHeader2 = _interopRequireDefault(_SubHeader);
	
	var _InlineLink = __webpack_require__(168);
	
	var _InlineLink2 = _interopRequireDefault(_InlineLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return [_react2.default.createElement(
	    _SubHeader2.default,
	    null,
	    'About Me'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'Hi, I\'m Lee Roberts. I\'m the COO of Duckly and a freelance web developer. I specialize in Ruby on Rails, JavaScript and React, but enjoy a little Python also. I am passionate about TDD, Linux, and OSS. I love writing well-tested code and solving unusual coding problems. I\'m a programming language fanatic and am currently investigating Elixir and Crystal, and reading up on functional programming concepts.'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'I live in Sandy Springs, GA with Ally, my beautiful and brilliant wife who loves me in spite of endless hours plastered to a monitor. When I\'m not coding or blogging, you can find me creating cubist oil paintings, breaking a computer trying the latest Linux flavor, or in the great outdoors.'
	  ), _react2.default.createElement(
	    'p',
	    null,
	    'If you have web development needs or have feedback on the blog, you can reach me via the\xA0',
	    _react2.default.createElement(
	      _InlineLink2.default,
	      { to: '/contact' },
	      'contact form'
	    ),
	    '.'
	  )];
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-ac6113eff15d0f803dc6.js